import presentingComplaintOptions from '../../../../patientRecords/ePCR/History/presentingComplaintOptions'

// Presenting complaint categories only exist on the client, so the server
// returns raw complaint counts and they are grouped here.
const CATEGORY_BY_LABEL = new Map(
  Object.entries(presentingComplaintOptions).flatMap(([category, options]) =>
    options.map((option) => [option.label.toLowerCase(), category]),
  ),
)

export const complaintCategory = (label) =>
  CATEGORY_BY_LABEL.get(String(label).trim().toLowerCase()) || 'Other'

// { complaint: count } -> { category: count }
export const categoriseComplaints = (complaints = {}) => {
  const out = {}
  Object.entries(complaints).forEach(([label, count]) => {
    const category = complaintCategory(label)
    out[category] = (out[category] || 0) + count
  })
  return out
}
